import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { StatusPill } from '@lyearn/ui';
import { ResourceStatusEnum } from '@/types/schema';
import { RESOURCE_STATUS_PILL_CONFIG } from '@/utils/resourceStatusPillConfig';

function StatusLabel(props: { status?: ResourceStatusEnum }) {
  const { t } = useTranslation();
  const { status } = props;

  if (!status) {
    return null;
  }

  const tag = RESOURCE_STATUS_PILL_CONFIG[status];

  if (!tag) {
    return null;
  }

  return (
    <StatusPill appearance={tag.appearance} className="ms-12" label={t(tag.key)} variant="light" />
  );
}

export default React.memo(StatusLabel);
